import { render } from "./LogoMercedes.vue?vue&type=template&id=0a50f4ed&scoped=true"
import script from "./LogoMercedes.vue?vue&type=script&lang=js"
export * from "./LogoMercedes.vue?vue&type=script&lang=js"

import "./LogoMercedes.vue?vue&type=style&index=0&id=0a50f4ed&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a50f4ed"]])

export default __exports__